<template>
  <authentication-layout>
    <header slot="form-header" class="header">
      <h2 class="title">Entre com sua conta de {{userType() == 'User' ? 'Usuário' : 'Administrador'}}</h2>
    </header>

    <template slot="form-content">
      <v-card class="elevation-0">
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="cpfcnpj"
              @keypress.enter="login(cpfcnpj, password)"
              mask="###.###.###-##"
              label="CPF"
              type="text"
            />

            <v-text-field
              v-model="password"
              :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
              :append-icon-cb="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              @keypress.enter="login(cpfcnpj, password)"
              label="Senha"
              hint="Mínimo de 8 caracteres"
              min="8"
            />
          </v-form>
        </v-card-text>

        <v-card-actions class="action">
          <v-btn flat small class="link-recovery" :to="`/${userAlias()}/conta/senha/recuperar`">
            <v-icon left>mdi-lock-outline mdi-18px</v-icon>
            <span class="text">Esqueci minha senha</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn large color="primary" v-on:click="login(cpfcnpj, password)">Entrar</v-btn>
        </v-card-actions>
        <v-alert outline color="error" icon="mdi-alert" :value="loginFailed" class="text-md-center">
          <div v-html="loginFailedMessage"></div>
        </v-alert>
      </v-card>

      <v-layout column justify-center align-center class="mt-4" v-if="userType() == 'User'">
        <span class="text">Ainda não possui acesso?</span>

        <v-btn flat small color="primary" class="link" :to="`/${userAlias()}/conta/cadastrar`">
          <span class="text">Faça seu cadastro</span>
        </v-btn>
      </v-layout>
      <consult-process-dialog/>
    </template>

    <!--<template slot="navigation" v-if="userType() == 'User'">-->

    <!--</template>-->
  </authentication-layout>
</template>

<script>
import axios from 'axios';
import AuthenticationLayout from '@/layouts/AuthenticationLayout';
import ConsultProcessDialog from '@/components/account/authentication/ConsultProcessDialog';
import AuthenticationService from '@/services/AuthenticationService';

export default {
  name: 'Login',
  components: {
    AuthenticationLayout,
    AuthenticationService,
    ConsultProcessDialog,
  },
  data() {
    return {
      cpfcnpj: '',
      password: '',
      loginFailed: '',
      loginFailedMessage: '',
      e1: true,
      isLoading: false,
    };
  },
  methods: {
    login(cpfcnpj, password) {
      this.$store.dispatch('setLoadingDialog', true);
      const vm = this;
      vm.isLoading = true;
      const userType = this.$router.history.current.meta.userType;
      const userAlias = this.$router.history.current.meta.userAlias;
      AuthenticationService
        .login(cpfcnpj, password, userType)
        .then(({ data }) => {
          axios.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;

          localStorage.setItem('access_token', data.access_token);
          localStorage.setItem('user', JSON.stringify(data.user));
          this.$store.dispatch('setCurrentUser', data.user);
          if (this.$store.getters.redirectTo === null) {
            this.$router.push(`/${userAlias}/requerimentos/lista`);
          } else {
            this.$router.push(this.$store.getters.redirectTo);
            this.$store.dispatch('setRedirectTo', null);
          }
        })
        .catch(({response}) => {
          this.loginFailed = true;
          this.loginFailedMessage = response.data.join(', ');
        })
        .finally(() => {
          vm.isLoading = false;
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    userAlias() {
      return this.$router.history.current.meta.userAlias;
    },
    userType() {
      return this.$router.history.current.meta.userType;
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  .link-recovery {
    text-transform: none;
  }
}
.navigation {
  > .link {
    font-size: 1.2rem;
    text-decoration: underline;
  }
}
</style>
